module.exports = __webpack_public_path__ + "static/media/soulstone-usecase.554880da.png";